import { useEffect } from 'react';

import { useGoogleAutocomplete } from './useGoogleAutocomplete';

export const useGooglePlaceSearchResults = ({
  businessName = '',
  googleBusinessName = '',
  setShouldHideResults,
  shouldHideResults,
} = {}) => {
  const {
    clearPredictions,
    getAutocompletePredictions,
    hasNoResultsRef,
    placePredictions,
  } = useGoogleAutocomplete();

  useEffect(() => {
    if (businessName?.length < 2) {
      clearPredictions();
    } else {
      getAutocompletePredictions(businessName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessName]);

  useEffect(() => {
    if (googleBusinessName !== businessName && shouldHideResults) {
      // do not hide results if businessName has changed
      // and is different to gmb businessName
      setShouldHideResults(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessName, googleBusinessName]);

  useEffect(() => {
    setShouldHideResults(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    clearPredictions,
    getAutocompletePredictions,
    hasNoResultsRef,
    placePredictions,
  };
};
